<template>
  <form @submit.prevent="handleFormSubmit">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="subject">Subject</label>
          <input
            type="text"
            name="subject"
            placeholder="Name or type of issue"
            class="form-control"
            v-model.trim="subject"
          />
        </div>
        <div class="form-group">
          <label for="message">Message</label>
          <textarea
            type="text"
            name="message"
            placeholder="Describe the issue"
            class="form-control"
            v-model="message"
          >
          </textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group text-right">
          <ActionButton
            label="Submit"
            :theme="{ primary, secondary, event, danger }"
            type="submit"
            style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import ActionButton from "@/components/ActionButton";

export default {
  name: "ReportABug",
  components: {
    ActionButton
    // VueSweetalert2
  },
  data() {
    return {
      subject: "",
      message: ""
    };
  },
  methods: {
    handleFormSubmit() {
      if (this.subject !== "" && this.subject !== "") {
        this.$swal({
          text: "Thank you for submitting your bug report!",
          type: "success"
        }).then(() => {
          this.$router.back();
        });
      }
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  }
};
</script>

<style lang="scss">
.swal2-content {
  font-family: "Gotham";
}
</style>
